module.exports = __webpack_public_path__ + "static/media/pz2.66d1235d.png";